import React from 'react';
import styles from './FilterCountBadge.module.scss';

interface ICountBadgeProps {
  count: number;
}

const FilterCountBadge = ({ count }: ICountBadgeProps) => {
  return (
    <span className={styles.Badge}>
      {count}
    </span>
  );
};

export default FilterCountBadge;
